import { render, staticRenderFns } from "./export-data.vue?vue&type=template&id=4a58c534&scoped=true&"
import script from "./export-data.vue?vue&type=script&lang=js&"
export * from "./export-data.vue?vue&type=script&lang=js&"
import style0 from "./export-data.vue?vue&type=style&index=0&id=4a58c534&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a58c534",
  null
  
)

export default component.exports